export const DEFAULT_MESSAGE = 'Request error'

const capitalizeFirstLetter = (s) => {
  if (typeof s !== 'string') return ''

  return `${s.charAt(0).toUpperCase()}${s.slice(1)}`
}

export const extractMessage = (error) => {
  if (!error || error.status === 500) {
    return DEFAULT_MESSAGE
  }

  if (error.status === 422 && error.attributes) {
    const messages = Object.values(error.attributes)
    // @TODO Clarify how we should handle the case of multiple attributes messages, since nui alerts.error is not expecting an array
    return messages.length === 1 ? capitalizeFirstLetter(messages[0]) : messages.map(capitalizeFirstLetter)
  }

  return typeof error.message === 'string' && error.message.trim().length > 0 ? capitalizeFirstLetter(error.message) : DEFAULT_MESSAGE
}

export const extractGraphQLErrors = (err) => {
  if (err.networkError) return [{ message: err.networkError.message }]

  // Apollo Client 4 uses err.errors; Apollo Client 3 used err.graphQLErrors
  const { errors } = err
  if (!errors?.length) return []

  return errors.map(({ message, extensions }) => ({
    message: message || extensions.message,
    status: extensions.code,
    attributes: extensions.attributes,
    type: extensions.response?.type,
  }))
}

export const extractGraphQLErrorMessage = (graphQlError) => {
  const errors = extractGraphQLErrors(graphQlError)
  return extractMessage(errors[0])
}

export default {}
